import React, { ReactNode, createContext, useContext } from 'react';
import { IOverloadedAdd, useCrudActivityList } from './use-crud-activity-list';

interface CrudActivityContextProps {
  children?: ReactNode;
}

interface CrudActivityContextValues {
  addCreating: IOverloadedAdd;
  addReading: IOverloadedAdd;
  addUpdating: IOverloadedAdd;
  addDeleting: IOverloadedAdd;
  isBusy: boolean;
  isCreating: boolean;
  isReading: boolean;
  isUpdating: boolean;
  isDeleting: boolean;
  removeCreating: (name: string) => void;
  removeReading: (name: string) => void;
  removeUpdating: (name: string) => void;
  removeDeleting: (name: string) => void;
}

const context = createContext(({} as unknown) as CrudActivityContextValues);

export const CrudActivityContext = ({ children }: CrudActivityContextProps) => {
  const [addCreating, removeCreating, isCreating] = useCrudActivityList();
  const [addReading, removeReading, isReading] = useCrudActivityList();
  const [addUpdating, removeUpdating, isUpdating] = useCrudActivityList();
  const [addDeleting, removeDeleting, isDeleting] = useCrudActivityList();

  const values = {
    addCreating,
    addReading,
    addUpdating,
    addDeleting,
    removeCreating,
    removeReading,
    removeUpdating,
    removeDeleting,
    isBusy: isCreating || isReading || isUpdating || isDeleting,
    isCreating,
    isReading,
    isUpdating,
    isDeleting
  };

  return <context.Provider value={values}>{children}</context.Provider>;
};

export const useCrudActivityContext = () => useContext(context);
